<template>
  <div>
    <input type="hidden" :value="newValue" />
    <el-select class="select" ref="select" size="small" v-model="selectValue" @change="select" :multiple="multiple" :filterable="filterable"  style="width:100%;">
      <el-option
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :value="option.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'pfSelect',
  props: {
    prop: String,
    api: {type: Function, default: null},
    options: {type: Array, default: () => []},
    value: String | Object,
    multiple: {type: Boolean, default: false},
    filterable: {type: Boolean, default: false}
  },
  data() {
    return {
      selectValue: ''
    }
  },
  computed: {
    newValue: {
      get() {
        this.selectValue = this.value
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  created() {
    if (this.api) {
      // 调用远程接口获取数据
      this.api.then(response => {
        response.forEach(element => {
          this.options.push({label: element.text, value: element.value})
        })
        // 初始化默认选中
        if (this.value) {
          this.options.forEach(item => {
            if (item.value == this.value) {
              this.selectValue = item.label
            }
          })
        }
      })
    }
  },
  methods: {
    select(data) {
      this.newValue = data
      setTimeout(() => {
        this.$refs.select.blur()
      }, 10)
    }
  }
}
</script>
